import config from '../config';

export const HEADER_TITLE = config.REACT_APP_HEADER_TITLE || 'HEADER.TITLE';
